<template>
  <section class="work-recent">
    <p>Recent projects go here</p>
  </section>
</template>

<script>
export default {
  name: 'WorkRecent',
  props: {
    view: String
  }
}
</script>

<style scoped>

</style>
